import React, { useState } from "react";
import { Field, ErrorMessage } from "formik";
import _ from "lodash";

// Types
import { sipTab } from "src/types";

// Components
import Icomput from "src/components/icomput";
import IcomSwitchBtn from "src/components/icom-switch-btn";

interface SIPProps {
  currentConfig: sipTab;
  setConfig: (config: any) => void;
  changeRegister: () => void;
}

const SIP: React.FC<SIPProps> = ({
  currentConfig,
  setConfig,
  changeRegister,
}) => {
  const [paNumber, setPaNumber] = useState(currentConfig.paNumber);

  const dispatherPaNumber = (event: React.FocusEvent<HTMLInputElement>) => {
    setConfig({ paNumber });
  };

  const handlePaNumber = (event: React.ChangeEvent<HTMLInputElement>) => {
    changeRegister();
    event.target.value = event.target.value.replace(/\D/g, "");
    setPaNumber(event.target.value);
  };

  const handleManualConfiguration = (value: boolean) => {
    changeRegister();
    setConfig({ manualConfiguration: value });
  };

  const handleInternalUse = (value: boolean) => {
    changeRegister();
    setConfig({ internalUse: value });
  };

  return (
    <>
      <div className="max-w-[337px] mb-10">
        <div className="form-group flex flex-col gap-3">
          <span className="text-sm font-bold text-neutral-gray-800 dark:text-neutral-gray-50">
            Número da PA
          </span>
          <Icomput
            value={paNumber}
            onChange={handlePaNumber}
            onBlur={dispatherPaNumber}
            placeholder="2000"
            type="number"
            className="text-neutral-gray-600 dark:text-neutral-gray-50 dark:bg-neutral-gray-800 dark:border-neutral-gray-800!"
          />
        </div>
      </div>

      {/*  <div className="form-group flex flex-col gap-3 mb-10">
        <span className="text-sm font-bold text-neutral-gray-800 dark:text-neutral-gray-50">
          Configuração Manual
        </span>
        <IcomSwitchBtn
          handleValue={handleManualConfiguration}
          currentValue={currentConfig.manualConfiguration}
          type="button"
        />
      </div> */}

      {/*  <div className="form-group flex flex-col gap-3 mb-10">
        <span className="text-sm font-bold text-neutral-gray-800 dark:text-neutral-gray-50">
          Uso Interno
        </span>
        <IcomSwitchBtn
          handleValue={handleInternalUse}
          currentValue={currentConfig.internalUse}
          type="button"
        />
      </div> */}
    </>
  );
};

export default SIP;
